<ng-container *ngIf="loadingContent">
  <h2 id="modal-title" class="sr-only">
    <span *ngIf="!groupOrder">{{'component.group_order_invitation.create_new_group_order' | translate}}</span>
    <span *ngIf="changeExpirationMode">{{'component.group_order_info.change_time_details' | translate}}</span>
    <span *ngIf="groupOrder && !changeExpirationMode">{{'component.group_order_invitation.invite_friends' | translate}}</span>
  </h2>
  <fts-loading-indicator [topPadding]="true"></fts-loading-indicator>
</ng-container>
<ng-container #content></ng-container>
